import { render } from "./DeviceBlacklist.vue?vue&type=template&id=387cb6c8&scoped=true"
import script from "./DeviceBlacklist.vue?vue&type=script&lang=js"
export * from "./DeviceBlacklist.vue?vue&type=script&lang=js"

import "./DeviceBlacklist.vue?vue&type=style&index=0&id=387cb6c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387cb6c8"]])

export default __exports__